export default __webpack_public_path__ + "b892c653b2d38db913ceb653c2209840.svg";